export default __webpack_public_path__ + "static/media/poland-flag-icon.a9d01805.svg";